import { ConditionalRedirect } from '../../type';
import { fillUrlPlaceholders } from '../../../../../utils/queryParams/fillUrlPlaceholders';
import { pickRedirect } from './pickRedirect';

/**
 * Picks the redirect the submission leads to, with the `{{field}}` placeholders
 * of its query string filled in from what was submitted - that is how a form
 * hands values over to the form it redirects to.
 */
export const resolveRedirect = (
  conditionalRedirects: ConditionalRedirect[] | undefined,
  formattedValues: Record<string, string>,
  defaultRedirect: string | undefined,
): string | undefined => {
  const target = pickRedirect({
    conditionalRedirects,
    formattedValues,
    defaultRedirect,
  });

  if (!target) return undefined;

  return fillUrlPlaceholders({ url: target, values: formattedValues });
};
